import { render } from "./subvertical.vue?vue&type=template&id=166164f4&scoped=true&ts=true"
import script from "./subvertical.vue?vue&type=script&lang=ts"
export * from "./subvertical.vue?vue&type=script&lang=ts"

import "./subvertical.vue?vue&type=style&index=0&id=166164f4&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166164f4"]])

export default __exports__